import type { JSX } from "react/jsx-runtime";
import type { FooterLink } from "../types/footer.ts";
import type { FooterTab } from "./FooterTabButton.tsx";

type Props = {
  tab: FooterTab;
  isActive: boolean;
};

function FooterTabPanel({ tab, isActive }: Props): JSX.Element {
  return (
    <div
      key={tab.id}
      id={tab.id}
      role="tabpanel"
      aria-labelledby={`tab-${tab.id}`}
      hidden={!isActive}
    >
      {tab.rows.map((row, index) => (
        <ul
          className="m-none flex list-none flex-wrap justify-center p-none"
          key={`${row[0].name}${index}`}
        >
          {row.map((link) => (
            <li key={link.name}>
              {link.type === "static" ? (
                <StaticLink footerLink={link} />
              ) : (
                <DynamicLink footerLink={link} />
              )}
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
}

function DynamicLink({ footerLink }: { footerLink: FooterLink }): JSX.Element {
  const { name, link, before, after, type } = footerLink;
  return (
    <>
      {before}
      <a
        key={name}
        href={link}
        className="mr-xsmall inline-flex min-h-large items-center text-bodySmall font-regular text-onSurfaceSubdued hover:underline"
        data-type={type}
      >
        {name}
      </a>
      {after}
    </>
  );
}

function StaticLink({ footerLink }: { footerLink: FooterLink }): JSX.Element {
  const { name, link } = footerLink;
  return (
    <a
      key={name}
      href={link}
      className="mr-xsmall inline-flex min-h-large items-center font-regular text-onSurfaceSubdued hover:underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      {name}
    </a>
  );
}

export default FooterTabPanel;
